const financialReportCopy = {
  "es": {
    "Resumen General": "Resumen General",
    "Balance General": "Balance General",
    "Estado de Resultados": "Estado de Resultados",
    "Flujo de Caja": "Flujo de Caja",
    "Hoy": "Hoy",
    "Esta Semana": "Esta Semana",
    "Este Mes": "Este Mes",
    "Este Año": "Este Año",
    "Personalizado": "Personalizado",
    "Ventas": "Ventas",
    "Otros Ingresos": "Otros Ingresos",
    "Costo Ventas": "Costo Ventas",
    "Gastos Op.": "Gastos Op.",
    "Nómina": "Nómina",
    "Compras": "Compras",
    "Ingresos": "Ingresos",
    "Total Ingresos": "Total Ingresos",
    "Gastos": "Gastos",
    "Costo de Ventas": "Costo de Ventas",
    "Gastos Operativos": "Gastos Operativos",
    "Total Gastos": "Total Gastos",
    "Utilidades": "Utilidades",
    "Utilidad Bruta": "Utilidad Bruta",
    "Utilidad Neta": "Utilidad Neta",
    "Utilidad bruta": "Utilidad bruta",
    "Utilidad neta": "Utilidad neta",
    "Ventas - Costo de Ventas": "Ventas - Costo de Ventas",
    "Ingresos - Gastos Totales": "Ingresos - Gastos Totales",
    "Ingresos y gastos": "Ingresos y gastos",
    "Importes por concepto; no representan partes de un mismo total.": "Importes por concepto; no representan partes de un mismo total.",
    "Importe": "Importe",
    "Utilidades del período": "Utilidades del período",
    "Los valores negativos representan pérdidas.": "Los valores negativos representan pérdidas.",
    "Utilidad": "Utilidad",
    "Ventas Realizadas": "Ventas Realizadas",
    "Venta Promedio": "Venta Promedio",
    "Margen de Ganancia": "Margen de Ganancia",
    "Cuentas por Pagar": "Cuentas por Pagar",
    "Balance operativo simplificado a partir de los registros del período. Los saldos iniciales, ajustes contables y valores de inventario no están incluidos en este cálculo.": "Balance operativo simplificado a partir de los registros del período. Los saldos iniciales, ajustes contables y valores de inventario no están incluidos en este cálculo.",
    "Activos": "Activos",
    "Activos Corrientes": "Activos Corrientes",
    "Efectivo": "Efectivo",
    "Cuentas por Cobrar": "Cuentas por Cobrar",
    "Total Activos": "Total Activos",
    "Pasivos": "Pasivos",
    "Salarios por Pagar": "Salarios por Pagar",
    "Total Pasivos": "Total Pasivos",
    "Patrimonio": "Patrimonio",
    "Utilidades Retenidas": "Utilidades Retenidas",
    "Total Patrimonio": "Total Patrimonio",
    "Balance general": "Balance general",
    "Activos, pasivos y patrimonio conservan su signo. Son magnitudes contables, no porcentajes de un total.": "Activos, pasivos y patrimonio conservan su signo. Son magnitudes contables, no porcentajes de un total.",
    "INGRESOS": "INGRESOS",
    "Ingresos por Ventas": "Ingresos por Ventas",
    "COSTO DE VENTAS": "COSTO DE VENTAS",
    "Costo de Productos Vendidos": "Costo de Productos Vendidos",
    "UTILIDAD BRUTA": "UTILIDAD BRUTA",
    "GASTOS OPERATIVOS": "GASTOS OPERATIVOS",
    "Gastos Generales": "Gastos Generales",
    "Total Gastos Operativos": "Total Gastos Operativos",
    "UTILIDAD OPERATIVA": "UTILIDAD OPERATIVA",
    "UTILIDAD NETA": "UTILIDAD NETA",
    "Entradas de Efectivo": "Entradas de Efectivo",
    "Salidas de Efectivo": "Salidas de Efectivo",
    "Flujo Neto": "Flujo Neto",
    "Actividades Operativas": "Actividades Operativas",
    "Efectivo de Ventas": "Efectivo de Ventas",
    "Pagos a Proveedores": "Pagos a Proveedores",
    "Pagos de Gastos": "Pagos de Gastos",
    "Pagos de Cuentas": "Pagos de Cuentas",
    "Entradas y salidas por fecha": "Entradas y salidas por fecha",
    "Los importes que el servidor no distribuye por fecha aparecen como Sin desglose diario.": "Los importes que el servidor no distribuye por fecha aparecen como Sin desglose diario.",
    "Entradas": "Entradas",
    "Salidas": "Salidas",
    "Flujo neto diario": "Flujo neto diario",
    "Flujo neto": "Flujo neto",
    "Entradas menos salidas; las salidas superiores a entradas se muestran bajo cero.": "Entradas menos salidas; las salidas superiores a entradas se muestran bajo cero.",
    "Desglose Diario": "Desglose Diario",
    "Neto": "Neto",
    "Fecha inicial del reporte": "Fecha inicial del reporte",
    "Fecha final del reporte": "Fecha final del reporte",
    "Selecciona una fecha inicial y una fecha final posterior.": "Selecciona una fecha inicial y una fecha final posterior.",
    "Período:": "Período:",
    "Sin fecha": "Sin fecha",
    "Sin desglose diario": "Sin desglose diario"
  },
  "en": {
    "Resumen General": "Overview",
    "Balance General": "Balance Sheet",
    "Estado de Resultados": "Income Statement",
    "Flujo de Caja": "Cash Flow",
    "Hoy": "Today",
    "Esta Semana": "This Week",
    "Este Mes": "This Month",
    "Este Año": "This Year",
    "Personalizado": "Custom",
    "Ventas": "Sales",
    "Otros Ingresos": "Other Income",
    "Costo Ventas": "Cost of Sales",
    "Gastos Op.": "Operating Exp.",
    "Nómina": "Payroll",
    "Compras": "Purchases",
    "Ingresos": "Income",
    "Total Ingresos": "Total Income",
    "Gastos": "Expenses",
    "Costo de Ventas": "Cost of Sales",
    "Gastos Operativos": "Operating Expenses",
    "Total Gastos": "Total Expenses",
    "Utilidades": "Profit",
    "Utilidad Bruta": "Gross Profit",
    "Utilidad Neta": "Net Profit",
    "Utilidad bruta": "Gross profit",
    "Utilidad neta": "Net profit",
    "Ventas - Costo de Ventas": "Sales − Cost of Sales",
    "Ingresos - Gastos Totales": "Income − Total Expenses",
    "Ingresos y gastos": "Income and Expenses",
    "Importes por concepto; no representan partes de un mismo total.": "Amounts by category; these are not portions of a single total.",
    "Importe": "Amount",
    "Utilidades del período": "Profit for the Period",
    "Los valores negativos representan pérdidas.": "Negative values represent losses.",
    "Utilidad": "Profit",
    "Ventas Realizadas": "Completed Sales",
    "Venta Promedio": "Average Sale",
    "Margen de Ganancia": "Profit Margin",
    "Cuentas por Pagar": "Accounts Payable",
    "Balance operativo simplificado a partir de los registros del período. Los saldos iniciales, ajustes contables y valores de inventario no están incluidos en este cálculo.": "Simplified operating balance based on the period’s records. Opening balances, accounting adjustments and inventory values are excluded from this calculation.",
    "Activos": "Assets",
    "Activos Corrientes": "Current Assets",
    "Efectivo": "Cash",
    "Cuentas por Cobrar": "Accounts Receivable",
    "Total Activos": "Total Assets",
    "Pasivos": "Liabilities",
    "Salarios por Pagar": "Salaries Payable",
    "Total Pasivos": "Total Liabilities",
    "Patrimonio": "Equity",
    "Utilidades Retenidas": "Retained Earnings",
    "Total Patrimonio": "Total Equity",
    "Balance general": "Balance Sheet",
    "Activos, pasivos y patrimonio conservan su signo. Son magnitudes contables, no porcentajes de un total.": "Assets, liabilities and equity retain their signs. These are accounting amounts, not percentages of a total.",
    "INGRESOS": "INCOME",
    "Ingresos por Ventas": "Sales Revenue",
    "COSTO DE VENTAS": "COST OF SALES",
    "Costo de Productos Vendidos": "Cost of Goods Sold",
    "UTILIDAD BRUTA": "GROSS PROFIT",
    "GASTOS OPERATIVOS": "OPERATING EXPENSES",
    "Gastos Generales": "General Expenses",
    "Total Gastos Operativos": "Total Operating Expenses",
    "UTILIDAD OPERATIVA": "OPERATING PROFIT",
    "UTILIDAD NETA": "NET PROFIT",
    "Entradas de Efectivo": "Cash Inflows",
    "Salidas de Efectivo": "Cash Outflows",
    "Flujo Neto": "Net Cash Flow",
    "Actividades Operativas": "Operating Activities",
    "Efectivo de Ventas": "Cash from Sales",
    "Pagos a Proveedores": "Payments to Suppliers",
    "Pagos de Gastos": "Expense Payments",
    "Pagos de Cuentas": "Bill Payments",
    "Entradas y salidas por fecha": "Inflows and Outflows by Date",
    "Los importes que el servidor no distribuye por fecha aparecen como Sin desglose diario.": "Amounts not allocated to a date by the server appear as No daily breakdown.",
    "Entradas": "Inflows",
    "Salidas": "Outflows",
    "Flujo neto diario": "Daily Net Cash Flow",
    "Flujo neto": "Net Cash Flow",
    "Entradas menos salidas; las salidas superiores a entradas se muestran bajo cero.": "Inflows minus outflows; outflows exceeding inflows are shown below zero.",
    "Desglose Diario": "Daily Breakdown",
    "Neto": "Net",
    "Fecha inicial del reporte": "Report Start Date",
    "Fecha final del reporte": "Report End Date",
    "Selecciona una fecha inicial y una fecha final posterior.": "Select a start date and an end date on or after it.",
    "Período:": "Period:",
    "Sin fecha": "No Date",
    "Sin desglose diario": "No Daily Breakdown"
  },
  "pt": {
    "Resumen General": "Visão geral",
    "Balance General": "Balanço patrimonial",
    "Estado de Resultados": "Demonstração de resultados",
    "Flujo de Caja": "Fluxo de caixa",
    "Hoy": "Hoje",
    "Esta Semana": "Esta semana",
    "Este Mes": "Este mês",
    "Este Año": "Este ano",
    "Personalizado": "Personalizado",
    "Ventas": "Vendas",
    "Otros Ingresos": "Outras receitas",
    "Costo Ventas": "Custo das vendas",
    "Gastos Op.": "Despesas oper.",
    "Nómina": "Folha de pagamento",
    "Compras": "Compras",
    "Ingresos": "Receitas",
    "Total Ingresos": "Receitas totais",
    "Gastos": "Despesas",
    "Costo de Ventas": "Custo das vendas",
    "Gastos Operativos": "Despesas operacionais",
    "Total Gastos": "Despesas totais",
    "Utilidades": "Lucros",
    "Utilidad Bruta": "Lucro bruto",
    "Utilidad Neta": "Lucro líquido",
    "Utilidad bruta": "Lucro bruto",
    "Utilidad neta": "Lucro líquido",
    "Ventas - Costo de Ventas": "Vendas − Custo das vendas",
    "Ingresos - Gastos Totales": "Receitas − Despesas totais",
    "Ingresos y gastos": "Receitas e despesas",
    "Importes por concepto; no representan partes de un mismo total.": "Valores por categoria; não representam partes de um mesmo total.",
    "Importe": "Valor",
    "Utilidades del período": "Lucros do período",
    "Los valores negativos representan pérdidas.": "Valores negativos representam prejuízos.",
    "Utilidad": "Lucro",
    "Ventas Realizadas": "Vendas realizadas",
    "Venta Promedio": "Venda média",
    "Margen de Ganancia": "Margem de lucro",
    "Cuentas por Pagar": "Contas a pagar",
    "Balance operativo simplificado a partir de los registros del período. Los saldos iniciales, ajustes contables y valores de inventario no están incluidos en este cálculo.": "Balanço operacional simplificado com base nos registros do período. Saldos iniciais, ajustes contábeis e valores de estoque não estão incluídos neste cálculo.",
    "Activos": "Ativos",
    "Activos Corrientes": "Ativos circulantes",
    "Efectivo": "Caixa",
    "Cuentas por Cobrar": "Contas a receber",
    "Total Activos": "Ativos totais",
    "Pasivos": "Passivos",
    "Salarios por Pagar": "Salários a pagar",
    "Total Pasivos": "Passivos totais",
    "Patrimonio": "Patrimônio líquido",
    "Utilidades Retenidas": "Lucros acumulados",
    "Total Patrimonio": "Patrimônio líquido total",
    "Balance general": "Balanço patrimonial",
    "Activos, pasivos y patrimonio conservan su signo. Son magnitudes contables, no porcentajes de un total.": "Ativos, passivos e patrimônio mantêm seus sinais. São valores contábeis, não percentuais de um total.",
    "INGRESOS": "RECEITAS",
    "Ingresos por Ventas": "Receita de vendas",
    "COSTO DE VENTAS": "CUSTO DAS VENDAS",
    "Costo de Productos Vendidos": "Custo dos produtos vendidos",
    "UTILIDAD BRUTA": "LUCRO BRUTO",
    "GASTOS OPERATIVOS": "DESPESAS OPERACIONAIS",
    "Gastos Generales": "Despesas gerais",
    "Total Gastos Operativos": "Despesas operacionais totais",
    "UTILIDAD OPERATIVA": "LUCRO OPERACIONAL",
    "UTILIDAD NETA": "LUCRO LÍQUIDO",
    "Entradas de Efectivo": "Entradas de caixa",
    "Salidas de Efectivo": "Saídas de caixa",
    "Flujo Neto": "Fluxo líquido",
    "Actividades Operativas": "Atividades operacionais",
    "Efectivo de Ventas": "Caixa de vendas",
    "Pagos a Proveedores": "Pagamentos a fornecedores",
    "Pagos de Gastos": "Pagamentos de despesas",
    "Pagos de Cuentas": "Pagamentos de contas",
    "Entradas y salidas por fecha": "Entradas e saídas por data",
    "Los importes que el servidor no distribuye por fecha aparecen como Sin desglose diario.": "Os valores que o servidor não distribui por data aparecem como Sem detalhamento diário.",
    "Entradas": "Entradas",
    "Salidas": "Saídas",
    "Flujo neto diario": "Fluxo líquido diário",
    "Flujo neto": "Fluxo líquido",
    "Entradas menos salidas; las salidas superiores a entradas se muestran bajo cero.": "Entradas menos saídas; saídas superiores às entradas são mostradas abaixo de zero.",
    "Desglose Diario": "Detalhamento diário",
    "Neto": "Líquido",
    "Fecha inicial del reporte": "Data inicial do relatório",
    "Fecha final del reporte": "Data final do relatório",
    "Selecciona una fecha inicial y una fecha final posterior.": "Selecione uma data inicial e uma data final igual ou posterior.",
    "Período:": "Período:",
    "Sin fecha": "Sem data",
    "Sin desglose diario": "Sem detalhamento diário"
  },
  "fr": {
    "Resumen General": "Vue d’ensemble",
    "Balance General": "Bilan",
    "Estado de Resultados": "Compte de résultat",
    "Flujo de Caja": "Flux de trésorerie",
    "Hoy": "Aujourd’hui",
    "Esta Semana": "Cette semaine",
    "Este Mes": "Ce mois-ci",
    "Este Año": "Cette année",
    "Personalizado": "Personnalisé",
    "Ventas": "Ventes",
    "Otros Ingresos": "Autres revenus",
    "Costo Ventas": "Coût des ventes",
    "Gastos Op.": "Charges d’expl.",
    "Nómina": "Paie",
    "Compras": "Achats",
    "Ingresos": "Revenus",
    "Total Ingresos": "Total des revenus",
    "Gastos": "Charges",
    "Costo de Ventas": "Coût des ventes",
    "Gastos Operativos": "Charges d’exploitation",
    "Total Gastos": "Total des charges",
    "Utilidades": "Bénéfices",
    "Utilidad Bruta": "Bénéfice brut",
    "Utilidad Neta": "Bénéfice net",
    "Utilidad bruta": "Bénéfice brut",
    "Utilidad neta": "Bénéfice net",
    "Ventas - Costo de Ventas": "Ventes − Coût des ventes",
    "Ingresos - Gastos Totales": "Revenus − Total des charges",
    "Ingresos y gastos": "Revenus et charges",
    "Importes por concepto; no representan partes de un mismo total.": "Montants par catégorie ; ils ne représentent pas les parts d’un même total.",
    "Importe": "Montant",
    "Utilidades del período": "Bénéfices de la période",
    "Los valores negativos representan pérdidas.": "Les valeurs négatives représentent des pertes.",
    "Utilidad": "Bénéfice",
    "Ventas Realizadas": "Ventes réalisées",
    "Venta Promedio": "Vente moyenne",
    "Margen de Ganancia": "Marge bénéficiaire",
    "Cuentas por Pagar": "Dettes fournisseurs",
    "Balance operativo simplificado a partir de los registros del período. Los saldos iniciales, ajustes contables y valores de inventario no están incluidos en este cálculo.": "Bilan opérationnel simplifié à partir des écritures de la période. Les soldes d’ouverture, ajustements comptables et valeurs des stocks sont exclus de ce calcul.",
    "Activos": "Actif",
    "Activos Corrientes": "Actif circulant",
    "Efectivo": "Trésorerie",
    "Cuentas por Cobrar": "Créances clients",
    "Total Activos": "Total de l’actif",
    "Pasivos": "Passif",
    "Salarios por Pagar": "Salaires à payer",
    "Total Pasivos": "Total du passif",
    "Patrimonio": "Capitaux propres",
    "Utilidades Retenidas": "Bénéfices non distribués",
    "Total Patrimonio": "Total des capitaux propres",
    "Balance general": "Bilan",
    "Activos, pasivos y patrimonio conservan su signo. Son magnitudes contables, no porcentajes de un total.": "L’actif, le passif et les capitaux propres conservent leur signe. Ce sont des montants comptables, pas des pourcentages d’un total.",
    "INGRESOS": "REVENUS",
    "Ingresos por Ventas": "Revenus des ventes",
    "COSTO DE VENTAS": "COÛT DES VENTES",
    "Costo de Productos Vendidos": "Coût des marchandises vendues",
    "UTILIDAD BRUTA": "BÉNÉFICE BRUT",
    "GASTOS OPERATIVOS": "CHARGES D’EXPLOITATION",
    "Gastos Generales": "Frais généraux",
    "Total Gastos Operativos": "Total des charges d’exploitation",
    "UTILIDAD OPERATIVA": "RÉSULTAT D’EXPLOITATION",
    "UTILIDAD NETA": "BÉNÉFICE NET",
    "Entradas de Efectivo": "Entrées de trésorerie",
    "Salidas de Efectivo": "Sorties de trésorerie",
    "Flujo Neto": "Flux net",
    "Actividades Operativas": "Activités d’exploitation",
    "Efectivo de Ventas": "Encaissements des ventes",
    "Pagos a Proveedores": "Paiements aux fournisseurs",
    "Pagos de Gastos": "Paiements des charges",
    "Pagos de Cuentas": "Paiements de factures",
    "Entradas y salidas por fecha": "Entrées et sorties par date",
    "Los importes que el servidor no distribuye por fecha aparecen como Sin desglose diario.": "Les montants non répartis par date par le serveur apparaissent sous Sans détail quotidien.",
    "Entradas": "Entrées",
    "Salidas": "Sorties",
    "Flujo neto diario": "Flux net quotidien",
    "Flujo neto": "Flux net",
    "Entradas menos salidas; las salidas superiores a entradas se muestran bajo cero.": "Entrées moins sorties ; les sorties dépassant les entrées sont affichées sous zéro.",
    "Desglose Diario": "Détail quotidien",
    "Neto": "Net",
    "Fecha inicial del reporte": "Date de début du rapport",
    "Fecha final del reporte": "Date de fin du rapport",
    "Selecciona una fecha inicial y una fecha final posterior.": "Sélectionnez une date de début et une date de fin égale ou ultérieure.",
    "Período:": "Période :",
    "Sin fecha": "Sans date",
    "Sin desglose diario": "Sans détail quotidien"
  }
};
export default financialReportCopy;
